import { PANELS } from '@helpers/constants'
import {
  SET_SELECTED_BOOK_ID,
  SET_SELECTED_BOOK_TITLE,
  SET_SELECTED_SECTION_ID,
  SET_EDIT_MODE,
  SET_CURRENT_SECTION,
  SET_CURRENT_ADD_SECTION_TO_BOOK_OBJECT,
  SET_CURRENT_EDIT_BOOK_OBJECT,
  SET_CURRENT_EDIT_CLASS_OBJECT,
  SET_EDIT_BOOK_PANEL_START_ON_TAB,
  SET_CURRENT_EDIT_BOOK_ID,
  SET_MAIN_ELEMENT,
  SET_SHOW_ONBOARDING_PROGRESS_BLOCK,
  INCREASE_SHOWN_TOOLTIPS_COUNT,
  SET_CURRENT_EXAM,
  SET_CURRENT_ACTIVE_EXAM,
  SET_CURRENT_ACTIVE_EXAM_ATTEMPT_ID,
  SET_CURRENT_SESSION_LATEST_FINISHED_EXAM,
  ON_CLOSE_EXAM,
  SET_SELECTED_STUDENT,
  SET_SELECTED_BOOK_FOR_PROGRESS_INSPECTION,
  SET_SELECTED_SECTION_FOR_PROGRESS_INSPECTION,
  SET_SELECTED_SCHOOL_RESOURCE_FOR_PROGRESS_INSPECTION,
  SET_SELECTED_INSPECTION_STATUS,
  SET_CURRENT_EXAM_ATTEMPT_IN_PROGRESS_ID,
  SET_SELECTED_SCHOOL_RESOURCE_TYPE_FOR_PROGRESS_INSPECTION,
} from '@state/actions/appActions'

import { CLOSE_LAST_PANEL, CLOSE_PANEL } from '@state/actions/panelsActions'

const initialAppState = {
  userId: window.user?.id,
  userName: window.user?.name,
  userEmail: window.user?.email,
  userImage: window.user?.image,
  userRole: window.user?.role,
  userSchools: window.user?.schools ? JSON.parse(window.user?.schools) : [],
  userSchoolClasses: window.user?.schoolClasses
    ? JSON.parse(window.user?.schoolClasses)
    : [],

  selectedBookId: null,
  selectedBookTitle: null,
  selectedSectionId: null,

  editMode: false,

  // Current add section to book object, adds section when book is created
  currentAddSectionToBookObject: null,

  // Current edit section object
  currentSection: null,

  // Current edit book object
  currentEditBookObject: null,

  // Current edit book object
  currentEditBookId: null,

  // Current edit school class object
  currentEditClassObject: null,

  // Special case for which tab in EditBookPanel to start on
  editBookPanelStartOnTab: null,

  // main content element (views/Layout/index.js)
  mainElement: undefined,

  showOnboardingProgressBlock: true,

  shownTooltips: 0,

  // Current edit exam object
  currentExam: null,

  // Exam currently beeing taken
  currentActiveExam: null,
  currentActiveExamAttemptId: null,

  currentSessionLatestFinishedExam: null,

  // Exam attempt in progress
  currentExamAttemptInProgressId: null,

  // Selected student in schoolClass view
  selectedStudent: null,

  // Selected book/section/resource(schoolClass or schoolGroup) for progress inspection
  selectedBookForProgressInspection: null,
  selectedSectionForProgressInspection: null,
  selectedSchoolResourceForProgressInspection: null,
  selectedSchoolResourceTypeForProgressInspection: null,
  selectedInspectionStatus: null,
}

/**
 * Reducer
 */
const appReducer = (state, action) => {
  switch (action.type) {
    case SET_SELECTED_BOOK_ID:
      return {
        ...state,
        selectedBookId: action.payload,
      }
    case SET_SELECTED_BOOK_TITLE:
      return {
        ...state,
        selectedBookTitle: action.payload,
      }
    case SET_SELECTED_SECTION_ID:
      return {
        ...state,
        selectedSectionId: action.payload,
      }
    case SET_EDIT_MODE:
      return {
        ...state,
        editMode: action.payload,
      }
    case SET_CURRENT_SECTION:
      if (state.mainElement) {
        state.mainElement.scrollTo(0, 0)
      }

      return {
        ...state,
        currentSection: action.payload,
      }
    case SET_CURRENT_ADD_SECTION_TO_BOOK_OBJECT:
      return {
        ...state,
        currentAddSectionToBookObject: action.payload,
      }
    case SET_CURRENT_EDIT_BOOK_OBJECT:
      return {
        ...state,
        currentEditBookObject: action.payload,
      }
    case SET_CURRENT_EDIT_BOOK_ID:
      return {
        ...state,
        currentEditBookId: action.payload,
      }
    case SET_CURRENT_EDIT_CLASS_OBJECT:
      return {
        ...state,
        currentEditClassObject: action.payload,
      }
    case SET_EDIT_BOOK_PANEL_START_ON_TAB:
      return {
        ...state,
        editBookPanelStartOnTab: action.payload,
      }
    case CLOSE_PANEL:
    case CLOSE_LAST_PANEL:
      if (
        action.type === CLOSE_LAST_PANEL ||
        action.payload === PANELS.CREATE_BOOK
      ) {
        return {
          ...state,
          currentAddSectionToBookObject: null,
        }
      }
      return state
    case SET_MAIN_ELEMENT:
      if (
        action.payload.element instanceof Element ||
        action.payload.element instanceof Document
      ) {
        return {
          ...state,
          mainElement: action.payload.element,
        }
      }
      return state
    case SET_SHOW_ONBOARDING_PROGRESS_BLOCK:
      return {
        ...state,
        showOnboardingProgressBlock: action.payload,
      }
    case INCREASE_SHOWN_TOOLTIPS_COUNT:
      return {
        ...state,
        shownTooltips: state.shownTooltips + 1,
      }
    case SET_CURRENT_EXAM:
      return {
        ...state,
        currentExam: action.payload,
      }
    case SET_CURRENT_ACTIVE_EXAM:
      return {
        ...state,
        currentActiveExam: action.payload,
      }
    case SET_CURRENT_ACTIVE_EXAM_ATTEMPT_ID:
      return {
        ...state,
        currentActiveExamAttemptId: action.payload,
      }
    case SET_CURRENT_SESSION_LATEST_FINISHED_EXAM:
      return {
        ...state,
        currentSessionLatestFinishedExam: action.payload,
      }
    case SET_CURRENT_EXAM_ATTEMPT_IN_PROGRESS_ID:
      return {
        ...state,
        currentExamAttemptInProgressId: action.payload,
      }
    case ON_CLOSE_EXAM:
      return {
        ...state,
        currentActiveExam: null,
        currentActiveExamAttemptId: null,
        currentExamAttemptInProgressId: null,
      }
    case SET_SELECTED_STUDENT:
      // Toggle
      if (action.payload?.id === state.selectedStudent?.id) {
        return {
          ...state,
          selectedStudent: null,
        }
      }

      // Else set
      return {
        ...state,
        selectedStudent: action.payload,
      }
    case SET_SELECTED_BOOK_FOR_PROGRESS_INSPECTION:
      return {
        ...state,
        selectedBookForProgressInspection: action.payload,
      }
    case SET_SELECTED_SECTION_FOR_PROGRESS_INSPECTION:
      return {
        ...state,
        selectedSectionForProgressInspection: action.payload,
      }
    case SET_SELECTED_SCHOOL_RESOURCE_FOR_PROGRESS_INSPECTION:
      return {
        ...state,
        selectedSchoolResourceForProgressInspection: action.payload,
      }
    case SET_SELECTED_SCHOOL_RESOURCE_TYPE_FOR_PROGRESS_INSPECTION:
      return {
        ...state,
        selectedSchoolResourceTypeForProgressInspection: action.payload,
      }
    case SET_SELECTED_INSPECTION_STATUS:
      return {
        ...state,
        selectedInspectionStatus: action.payload,
      }
    default:
      return state
  }
}

export { initialAppState, appReducer }
